import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { db } from '@/services';
import type { AppUser } from '@/types';
import { notifyLiveDataError } from '@/utils';

/** Subscribes to every user profile — admin-only (enforced by Firestore rules). */
export const useAllUsers = () => {
  const [users, setUsers] = useState<AppUser[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, 'users'), orderBy('displayName', 'asc'));
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        // The doc ID is always the Firebase Auth uid (see createUser.ts),
        // so derive `uid` from it rather than trusting the `uid` field —
        // some older/edited docs are missing that field, which broke name
        // lookups keyed by uid elsewhere in the app.
        setUsers(
          snapshot.docs.map((docSnap) => ({ ...(docSnap.data() as AppUser), uid: docSnap.id })),
        );
        setLoading(false);
      },
      (error) => {
        notifyLiveDataError('useAllUsers', error);
        setLoading(false);
      },
    );
    return unsubscribe;
  }, []);

  return { users, loading };
};
